import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2caf4c53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "process-templates" }
const _hoisted_2 = { class: "page" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  class: "btn btn-outline-primary me-3 float-end add-button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#addNewModal"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-3 ms-1 inline-block" }, "New", -1))
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body ps-0 pe-0" }
const _hoisted_9 = { class: "table table-hover" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Create")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Update")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "User")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    })
  ])
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block ms-3" }, null, -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block ms-4" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block ms-3" }, null, -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block ms-3" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_AddNewModal = _resolveComponent("AddNewModal")!
  const _component_AddModuleModal = _resolveComponent("AddModuleModal")!
  const _component_AddProcessModal = _resolveComponent("AddProcessModal")!
  const _component_AddSubProcessModal = _resolveComponent("AddSubProcessModal")!
  const _component_DeleteProcessModal = _resolveComponent("DeleteProcessModal")!
  const _component_DeleteModuleModal = _resolveComponent("DeleteModuleModal")!
  const _component_RenameModuleModal = _resolveComponent("RenameModuleModal")!
  const _component_RenameProcessModal = _resolveComponent("RenameProcessModal")!
  const _component_CloneProcessModal = _resolveComponent("CloneProcessModal")!
  const _component_DeleteSubProcessModal = _resolveComponent("DeleteSubProcessModal")!
  const _component_RenameSubProcessModal = _resolveComponent("RenameSubProcessModal")!
  const _component_CloneSubProcessModal = _resolveComponent("CloneSubProcessModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          _createTextVNode(" Explore Your Digital Blueprints Library "),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_feather_icon, {
              type: "plus",
              class: "cursor-pointer add-icon",
              size: "20"
            }),
            _hoisted_6
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.singleModules, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(["cursor-pointer modules", { odd: index }]),
                  key: item.name,
                  onClick: ($event: any) => (_ctx.selectedItemId = item.moduleId || item.typeId)
                }, [
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.gotToModule(item.processId, item.moduleId))
                  }, [
                    _createVNode(_component_feather_icon, {
                      type: "file",
                      class: "cursor-pointer module-icon",
                      size: "18"
                    }),
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(item.title), 1)
                  ], 8, _hoisted_12),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.gotToModule(item.processId, item.moduleId))
                  }, _toDisplayString(_ctx.format(item.createdAt)), 9, _hoisted_14),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.gotToModule(item.processId, item.moduleId))
                  }, _toDisplayString(_ctx.format(item.updatedAt)), 9, _hoisted_15),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.gotToModule(item.processId, item.moduleId))
                  }, _toDisplayString(item.jwt.email), 9, _hoisted_16),
                  _createElementVNode("td", _hoisted_17, [
                    _createVNode(_component_context_menu, {
                      onClick: _withModifiers(($event: any) => {_ctx.selectedItem = item; _ctx.selectedItemId = item.processId || item.typeId}, ["stop"]),
                      id: index,
                      links: _ctx.getModuleContextMenu(item)
                    }, null, 8, ["onClick", "id", "links"])
                  ])
                ], 10, _hoisted_11))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(["cursor-pointer", { odd: index }]),
                  key: item.name,
                  onClick: ($event: any) => (_ctx.selectedItemId = item.typeId)
                }, [
                  (!item.moduleId)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("td", {
                          onClick: ($event: any) => (_ctx.go(item.processId || item.typeId)),
                          class: _normalizeClass({ isSubType: item.isSubType })
                        }, [
                          _createVNode(_component_feather_icon, {
                            type: _ctx.openProcess[item.processId || item.typeId] ? 'chevron-down' : 'chevron-right',
                            class: "cursor-pointer",
                            size: "18",
                            onClick: _withModifiers(($event: any) => {_ctx.openProcess[item.processId || item.typeId] = !_ctx.openProcess[item.processId || item.typeId]; _ctx.getAllModulesFromProcessApi(item.processId || item.typeId)}, ["stop"])
                          }, null, 8, ["type", "onClick"]),
                          _hoisted_20,
                          _createVNode(_component_feather_icon, {
                            type: "folder",
                            class: "cursor-pointer",
                            size: "18"
                          }),
                          _hoisted_21,
                          _createTextVNode(" " + _toDisplayString(item.name), 1)
                        ], 10, _hoisted_19),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (_ctx.go(item.processId || item.typeId))
                        }, _toDisplayString(_ctx.format(item.createdAt)), 9, _hoisted_22),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (_ctx.go(item.processId || item.typeId))
                        }, [
                          (item.timestamp)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.format(item.timestamp)), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_23),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (_ctx.go(item.processId || item.typeId))
                        }, _toDisplayString(item.jwt.email), 9, _hoisted_25),
                        _createElementVNode("td", _hoisted_26, [
                          _createVNode(_component_context_menu, {
                            onClick: _withModifiers(($event: any) => (_ctx.selectedItemId = item.processId || item.typeId), ["stop"]),
                            id: index,
                            links: _ctx.getContextMenu(item)
                          }, null, 8, ["onClick", "id", "links"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (item.moduleId)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("td", {
                          class: _normalizeClass(["", `${item.isSubtItem ? 'ps-5' : 'ps-4'}`]),
                          onClick: ($event: any) => (_ctx.gotToModule(item.processId, item.moduleId))
                        }, [
                          _createVNode(_component_feather_icon, {
                            type: "file",
                            class: "cursor-pointer module-icon",
                            size: "18"
                          }),
                          _hoisted_28,
                          _createTextVNode(" " + _toDisplayString(item.title.slice(0, 40)) + _toDisplayString(item.title.length > 40 ? '...' : '') + " ", 1),
                          (item.stepId)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "milestone",
                                style: _normalizeStyle({ backgroundColor: _ctx.milestones[item.stepId]?.color })
                              }, _toDisplayString(_ctx.milestones[item.stepId]?.name), 5))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_27),
                        _hoisted_29,
                        _hoisted_30,
                        _hoisted_31,
                        _hoisted_32
                      ], 64))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_18))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_AddNewModal),
      _createVNode(_component_AddModuleModal),
      _createVNode(_component_AddProcessModal, {
        onAdded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go($event)))
      }),
      _createVNode(_component_AddSubProcessModal, {
        onAdded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go($event))),
        typeId: _ctx.selectedItemId
      }, null, 8, ["typeId"]),
      _createVNode(_component_DeleteProcessModal, { typeId: _ctx.selectedItemId }, null, 8, ["typeId"]),
      _createVNode(_component_DeleteModuleModal, {
        typeId: _ctx.selectedItem.moduleId
      }, null, 8, ["typeId"]),
      _createVNode(_component_RenameModuleModal, {
        typeId: _ctx.selectedItem.moduleId
      }, null, 8, ["typeId"]),
      _createVNode(_component_RenameProcessModal, { typeId: _ctx.selectedItemId }, null, 8, ["typeId"]),
      _createVNode(_component_CloneProcessModal, { typeId: _ctx.selectedItemId }, null, 8, ["typeId"]),
      _createVNode(_component_DeleteSubProcessModal, { processId: _ctx.selectedItemId }, null, 8, ["processId"]),
      _createVNode(_component_RenameSubProcessModal, { processId: _ctx.selectedItemId }, null, 8, ["processId"]),
      _createVNode(_component_CloneSubProcessModal, { processId: _ctx.selectedItemId }, null, 8, ["processId"])
    ])
  ]))
}